import {
  ANCESTOR_STEP_FAILED_ERROR_MESSAGE,
  TRANSFORMATION_STEP_TYPES,
} from 'analysis-tool/AnalysisToolConstants';
import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {isViewTerminalStepType} from 'analysis-tool/data/LineageStepTypes';
import {PipelineStepStatusCode, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ErrorHandlingOptions} from 'insights/universal-blocks/PresentationalUniversalBlockView';

import {REACH_OUT_TO_BENCHLING_TEXT} from '../main-view/MainViewConstants';
import {getRegressionErrorText, getTransformationErrorText} from '../main-view/MainViewHelpers';

export default function getDatasetViewErrorHandlingOptions(
  viewSteps: Array<GetAnalysisPipelineStep>,
  isReadOnly: boolean,
  ignoreTerminalStepErrors: boolean = false
): ErrorHandlingOptions | null {
  const firstFailedStep = viewSteps
    .filter((step) => !ignoreTerminalStepErrors || !isViewTerminalStepType(step.definition.stepType))
    .find((step) => step.statusCode === PipelineStepStatusCode.FAILED);
  if (firstFailedStep == null) {
    return null;
  }

  let errorMessage = `There was an error creating this view. ${REACH_OUT_TO_BENCHLING_TEXT}`;
  let showVisualization = false;

  if (firstFailedStep.statusMessage === ANCESTOR_STEP_FAILED_ERROR_MESSAGE) {
    errorMessage =
      'There was an error creating this view due to an error in the table configuration. Please update the table configuration to try again.';
  } else if (!isReadOnly && TRANSFORMATION_STEP_TYPES.includes(firstFailedStep.definition.stepType)) {
    errorMessage = getTransformationErrorText(firstFailedStep);
  } else if (firstFailedStep.definition.stepType === PipelineStepType.REGRESSION) {
    errorMessage = getRegressionErrorText(firstFailedStep) ?? errorMessage;
    showVisualization = true;
  } else if (firstFailedStep.definition.stepType === PipelineStepType.CHART_VIEW) {
    errorMessage = firstFailedStep.statusMessage ?? errorMessage;
  }

  return {errorMessage, showVisualization};
}
